export const GET_USER_SESSION_DATA = "[USER] GET_USER_SESSION_DATA";
export const SET_USER_SESSION_DATA = "[USER] SET_USER_SESSION_DATA";

export const SET_USER_SESSION_DATA_BY_KEY = "[USER] SET_USER_SESSION_DATA_BY_KEY";
export const CLEAR_USER_SESSION_DATA_BY_KEY = "[USER] CLEAR_USER_SESSION_DATA_BY_KEY";

export const getUserSessionData = (email) => {
    if (!email || email === "") {
        return null;
    }
    const userSessionData = sessionStorage.getItem(email);
    if (userSessionData) {
        return JSON.parse(userSessionData);
    }
    return null;
}

export const setUserSessionData = (email, sessionData) => {
    if (!email || email === "") {
        return;
    }
    if (sessionData) {
        sessionStorage.setItem(email, JSON.stringify(sessionData));
    }
}

export const getSessionDataByKey = (email, key) => {
    if (!email || email === "" || !key || key === "") {
        return null;
    }
    const userSessionDataString = sessionStorage.getItem(email);
    if (userSessionDataString) {
        const userSessionData = JSON.parse(userSessionDataString);
        return userSessionData[key];
    }
    return null;
}

export const setSessionDataByKey = (email, payload) => {
    const { key, value } = payload;
    if (!email || email === "" || !key || key === "") {
        return null;
    }
    const userSessionDataString = sessionStorage.getItem(email);
    let userSessionData = JSON.parse(userSessionDataString);
    userSessionData = {
        ...userSessionData,
        [key]: value
    };
    return sessionStorage.setItem(email, JSON.stringify(userSessionData));;
}